import { Reveal } from "@/components/Reveal";
import { Lock, EyeOff, ShieldCheck, KeyRound } from "lucide-react";

const IMG =
  "https://images.unsplash.com/photo-1613490493576-7fde63acd811?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBtb2Rlcm4lMjBhcmNoaXRlY3R1cmUlMjBlc3RhdGV8ZW58MHx8fHwxNzg5MTU1MTIxfDA&ixlib=rb-4.1.0&q=85";

const POINTS = [
  {
    icon: EyeOff,
    title: "You choose the audience",
    body: "Listing details are visible to every verified member — and if you'd rather keep a post quiet, you can restrict it to your own network only.",
  },
  {
    icon: Lock,
    title: "Agents only. Always.",
    body: "Nothing on PrimeConnect is public, indexable or crawlable. Membership is verified; consumers never see inside.",
  },
  {
    icon: ShieldCheck,
    title: "Verified credentials",
    body: "Every member is accredited against their agency before posting — no anonymous accounts, no tyre-kickers.",
  },
  {
    icon: KeyRound,
    title: "You control disclosure",
    body: "Client names and full addresses are shared only when you choose to share them — agent to agent, on your terms.",
  },
];

export const Discretion = () => (
  <section id="discretion" className="py-24 sm:py-32 bg-[#0E0F11] text-[#FAF9F5] relative overflow-hidden">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <div className="grid lg:grid-cols-2 gap-16 lg:gap-20 items-center">
        <div>
          <Reveal>
            <p className="font-eyebrow text-[11px] text-[#B89B6C]">Discretion</p>
            <h2 className="font-display font-medium tracking-tight text-4xl sm:text-5xl mt-5 leading-[1.08]">
              A sealed room for <em className="italic font-light">prime deals.</em>
            </h2>
            <p className="text-base text-[#FAF9F5]/55 leading-relaxed mt-6 max-w-lg">
              Your clients instruct you privately for a reason. PrimeConnect is a
              sealed room: off-market listings stay visible only to verified
              agents inside the network — never to the public, never to a portal,
              never to a search engine.
            </p>
          </Reveal>

          <div className="mt-12 grid sm:grid-cols-2 gap-x-10 gap-y-10">
            {POINTS.map((p, i) => (
              <Reveal key={p.title} delay={0.1 + i * 0.08}>
                <div data-testid={`discretion-point-${i}`}>
                  <p.icon size={20} className="text-[#D4C29E]" strokeWidth={1.5} />
                  <h3 className="font-display text-xl mt-4">{p.title}</h3>
                  <p className="text-sm text-[#FAF9F5]/50 leading-relaxed mt-2">{p.body}</p>
                </div>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.2}>
          <div className="relative">
            <div className="rounded-3xl overflow-hidden border border-[#FAF9F5]/10">
              <img
                src={IMG}
                alt="Private prime residence"
                className="w-full h-[420px] sm:h-[560px] object-cover opacity-80 grayscale-[35%]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0E0F11] via-transparent to-transparent" />
            </div>
            <div className="absolute bottom-6 left-6 right-6 sm:bottom-8 sm:left-8 sm:right-8 bg-[#0E0F11]/80 backdrop-blur-md border border-[#FAF9F5]/10 rounded-2xl p-6">
              <p className="font-eyebrow text-[9px] text-[#B89B6C]">Visibility</p>
              <p className="font-display italic text-xl sm:text-2xl mt-2 text-[#FAF9F5]">
                &ldquo;Members only. Everyone else sees nothing at all.&rdquo;
              </p>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
